import { SyntheticEvent } from 'react'

// material-ui

import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Fade from '@mui/material/Fade'
import Grow from '@mui/material/Grow'
import IconButton from '@mui/material/IconButton'
import Slide, { SlideProps } from '@mui/material/Slide'
import MuiSnackbar from '@mui/material/Snackbar'

// assets
import CloseIcon from '@mui/icons-material/Close'

import { KeyedObject } from 'types'
import { useDispatch, useSelector } from 'store'
import { closeSnackbar } from 'store/slices/snackbar'

// animation function
const TransitionSlideLeft = (props: SlideProps) => (
    <Slide {...props} direction="left" />
)

const TransitionSlideUp = (props: SlideProps) => (
    <Slide {...props} direction="up" />
)

const TransitionSlideRight = (props: SlideProps) => (
    <Slide {...props} direction="right" />
)

const TransitionSlideDown = (props: SlideProps) => (
    <Slide {...props} direction="down" />
)

const GrowTransition = (props: SlideProps) => <Grow {...props} />

// animation options
const animation: KeyedObject = {
    SlideLeft: TransitionSlideLeft,
    SlideUp: TransitionSlideUp,
    SlideRight: TransitionSlideRight,
    SlideDown: TransitionSlideDown,
    Grow: GrowTransition,
    Fade,
}

// ==============================|| SNACKBAR ||============================== //

const Snackbar = () => {
    const dispatch = useDispatch()
    const snackbar = useSelector((state) => state.snackbar)
    const {
        actionButton,
        anchorOrigin,
        alert,
        severity,
        close,
        message,
        open,
        transition,
        variant,
    } = snackbar

    const handleClose = (event: SyntheticEvent | Event, reason?: string) => {
        if (reason === 'clickaway') {
            return
        }
        dispatch(closeSnackbar())
    }

    return (
        <>
            {/* default snackbar */}
            {variant === 'default' && (
                <MuiSnackbar
                    anchorOrigin={anchorOrigin}
                    open={open}
                    autoHideDuration={3000}
                    onClose={handleClose}
                    message={message}
                    TransitionComponent={animation[transition]}
                    action={
                        <>
                            <Button
                                color="secondary"
                                size="small"
                                onClick={handleClose}
                            >
                                UNDO
                            </Button>
                            <IconButton
                                size="small"
                                aria-label="close"
                                color="inherit"
                                onClick={handleClose}
                                sx={{ mt: 0.25 }}
                            >
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </>
                    }
                />
            )}

            {/* alert snackbar */}
            {variant === 'alert' && (
                <MuiSnackbar
                    TransitionComponent={animation[transition]}
                    anchorOrigin={anchorOrigin}
                    open={open}
                    autoHideDuration={3000}
                    onClose={handleClose}
                >
                    <Alert
                        variant={alert.variant}
                        color={alert.color}
                        severity={severity as any}
                        action={
                            <>
                                {actionButton !== false && (
                                    <Button
                                        size="small"
                                        onClick={handleClose}
                                        sx={{ color: 'background.paper' }}
                                    >
                                        UNDO
                                    </Button>
                                )}
                                {close !== false && (
                                    <IconButton
                                        sx={{ color: 'background.paper' }}
                                        size="small"
                                        aria-label="close"
                                        onClick={handleClose}
                                    >
                                        <CloseIcon fontSize="small" />
                                    </IconButton>
                                )}
                            </>
                        }
                        sx={{
                            ...(alert.variant === 'outlined' && {
                                bgcolor: 'background.paper',
                            }),
                        }}
                    >
                        {message}
                    </Alert>
                </MuiSnackbar>
            )}
        </>
    )
}

export default Snackbar
